import { IService, ServiceType, ServiceManager } from "../ServiceManager";
import { Firebase } from "../ThirdParty/Firebase";
import { PROListAnalyticsCommandType, PROListAnalyticsAdapter, PROListAnalyticsClientData } from "../Analytics/PROListAnalyticsAdapter";

class ContactCorrelationAdapter implements IService {
  Type: ServiceType = ServiceType.ContactCorrelation;
  Id: string = 'ContactCorrelationAdapter';

  private PROListAnalytics: PROListAnalyticsAdapter | null;
  private Firebase: Firebase | null;

  private ClientId?: string;
  private ContactId?: string;

  constructor() {
    this.PROListAnalytics = ServiceManager.Get<PROListAnalyticsAdapter>(ServiceType.Analytics, 'PROListAnalyticsAdapter');
    this.Firebase = ServiceManager.Get<Firebase>(ServiceType.Firebase);

    this.PROListAnalytics?.On(PROListAnalyticsCommandType.ClientRegistered, (client: PROListAnalyticsClientData) => {
      this.ClientId = client.ClientId;

      if (client.ContactId) this.ContactId = client.ContactId;
    });
  }

  SetContactId(contactId: string) {
    this.ContactId = contactId;

    this.PROListAnalytics?.SetContactId(contactId);
  }
}

export { ContactCorrelationAdapter }
